import { render } from "./TosLayout.vue?vue&type=template&id=7b8211bc&scoped=true"
const script = {}

import "./TosLayout.vue?vue&type=style&index=0&id=7b8211bc&scoped=true&lang=scss"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8211bc"]])

export default __exports__